import { render, staticRenderFns } from "./whiteList.vue?vue&type=template&id=2b8b61cb&scoped=true&"
import script from "./whiteList.vue?vue&type=script&lang=js&"
export * from "./whiteList.vue?vue&type=script&lang=js&"
import style0 from "./whiteList.vue?vue&type=style&index=0&id=2b8b61cb&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8b61cb",
  null
  
)

export default component.exports